import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import {Link} from 'react-router-dom';

export const Regolamento = (props) => {

  const room = props.room;

  const stars = [];
  for (let i = 0; i < 60; i++) {
    // const posx = Math.floor(Math.random() * 100);
    // const posy = Math.floor(Math.random() * 100);
    // const w = Math.floor(Math.random() * 5) + 2;
    stars.push(<div className="star" key={i}  />);
  }

  return(
    <div className="pages" >
      {stars}

      <div className='logoMuseo'>
        <CommonSvgContent stringToRet="logoMuseo" />
      </div>

      <div className='collaborazione'>
        <p>In collaborazione con</p>
        <h3>INAF-Osservatorio<br />
        Astronomico<br />
        di Brera </h3>
      </div>


      <div className='logo'>
        <Link to="/"><ContentLanding stringToRet="logo" /></Link>
      </div>

      <div className="content">

        <h1>TERMINI E CONDIZIONI DI UTILIZZO E DI VENDITA</h1>
        <p>Le seguenti condizioni di utilizzo sono applicabili all’esperienza dell’escape room “M4RT3!” fruibile online sul sito escapemarte.museoscienza.it (di seguito anche definito il “Sito”), gestito da Fondazione Museo Nazionale della Scienza e della Tecnologia Leonardo da Vinci, con sede in Milano, via San Vittore 21, 20123 (di seguito il “MUST”).<br />
La partecipazione all’esperienza dell’Escape room “M4RT3!” presuppone la lettura, la conoscenza e l’accettazione delle presenti Condizioni di utilizzo.<br />
Si invita altresì a leggere attentamente la Privacy Policy e la Cookie Policy le quali si applicano a qualsiasi accesso al Sito da parte dell’utente e descrivono come il MUST raccoglie ed utilizza i dati personali dell’utente e per quali finalità.</p>
<h2>1. Condizioni di vendita del codice di gioco</h2>

<p>Per partecipare all’Escape room “M4RT3!” occorre acquistare un codice di gioco, emesso dal MUST.<br />
Il codice di gioco può essere acquistato in formato digitale sul portale vivaticket oppure mediante card fisica acquistabile presso il MUST Shop e i punti vendita autorizzati. In entrambi i casi il codice non ha scadenza e deve essere riscattato seguendo le istruzioni riportate sul Sito.<br />
Finché il codice non viene riscattato sul Sito, può essere ceduto a terzi. Una volta inserito sul Sito ed a seguito dal tasto “invio”, il codice si considera utilizzato e non può più essere ceduto o riutilizzato.<br />
Una volta trascorso il tempo di gioco, non sarà più possibile iniziare una nuova partita con lo stesso codice.<br />
Il codice di gioco non è rimborsabile e il MUST non è responsabile per l’utilizzo improprio, la perdita e l’acquisto di card fisiche.</p>

<h2>2. Regole di gioco</h2>
<p>Per vivere l’esperienza dell’Escape room online “M4RT3!” è necessario essere dotati di un pc con sistema operativo windows, mac o linux o di un tablet con una connessione a internet e un programma di navigazione (Chrome è consigliato). Non è necessario installare alcuna mobile app o scaricare alcun software.
Si può scegliere di giocare a “M4RT3!” individualmente oppure in gruppo. E’ possibile trovarsi nello stesso luogo e utilizzare il medesimo dispositivo (pc, tablet) oppure condividere il proprio schermo con altri partecipanti in remoto tramite un sistema di videochiamata. L’utilizzo dello smartphone non è consigliato.
Non esiste un limite al numero di partecipanti al gioco ma la fruizione ottimale dello stesso è stata individuata in un gruppo composto da massimo  6 persone. Si ricorda che è consigliato l’uso a giocatori con età superiore ai 12 anni.<br />
Da questo momento l’esperienza ha inizio e il giocatore ha a disposizione 90 minuti per risolvere tutti gli enigmi. L’Escape room si considera vinta se, allo scadere del tempo, tutti gli enigmi risulteranno risolti.<br />
Qualora venisse chiuso il programma di navigazione mentre è in corso la partita oppure la connessione internet si interrompesse, sarà sufficiente riaprire il programma e inserire nuovamente il proprio codice di gioco. La partita riprenderà dal punto in cui si era interrotta.</p>

<h2>3. Diritti di proprietà intellettuale</h2>
<p>L’esperienza dell’Escape room “M4RT3!” quanto al concept, struttura, testi, enigmi grafica e codice è di proprietà del MUST ed è protetta, senza limitazioni, dalla normativa vigente in materia di tutela del diritto d’autore e successive modifiche ed integrazioni.
L’utente si impegna pertanto a non riprodurre, pubblicare, ridistribuire o sfruttare in altro modo i Contenuti, in violazione dei diritti di proprietà intellettuale del MUST o di terzi.</p>

<h2>4. Contenuti generati dagli utenti</h2>
<p>L’Esperienza dell’Escape room fruibile sul Sito potrebbe includere contenuti provenienti dagli utenti/ giocatori, come messaggi, commenti o elaborazioni grafiche (di seguito i “Contenuti generati dagli utenti”). Il MUST non partecipa in alcun modo alla creazione o pubblicazione di tali Contenuti generati dagli utenti, né li approva, né garantisce che non ledano eventuali diritti di terzi o in altro modo la legge.
Il MUST non può pertanto essere ritenuto responsabile dei Contenuti generati dagli utenti.</p>

<h2>5. Link esterni</h2>
<p>Il Sito potrebbe contenere link o collegamenti ipertestuali riferiti a siti terzi, i quali non sono soggetti a controllo e verifiche da parte del MUST ma che potrebbero risultare funzionali per la risoluzione degli enigmi previsti dall’Escape Room.
La pubblicazione dei suddetti link o collegamenti ipertestuali non comporta l’approvazione da parte del MUST dei relativi siti e dei loro contenuti, né implica alcuna forma di garanzia da parte del medesimo.
L’utente riconosce pertanto che il MUST non è responsabile della veridicità, correttezza, rispetto dei diritti di proprietà intellettuale, della legalità dei suddetti siti o di qualsiasi altro aspetto legato ai medesimi, nonché della loro eventuale contrarietà all’ordine pubblico e/o alla morale.</p>

<h2>Limitazione di responsabilità</h2>
<p>Il MUST declina qualsiasi responsabilità per danni causati da virus, file danneggiati, errori, omissioni, interruzioni dell’Esperienza dell’Escape Room, problemi connessi alla rete, al provider o a collegamenti telematici, ad accessi non autorizzati, nonché al mancato e/o difettoso funzionamento delle apparecchiature elettroniche dell’utente stesso.</p>

<p>Per eventuali informazioni e assistenza tecnica scrivere a <a href="mailto:escape@museoscienza.it">escape@museoscienza.it</a></p>
        <Link className="btn btn-danger backTo" to="/">Torna</Link>

      </div>


    </div>
  )
}
